import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "lucide-react";

const AWARD_IMG = "https://customer-assets-lxgj4vgw.emergentagent.net/job_6dc3909f-878c-4eee-8cfe-c2f27fad2cc4/artifacts/f7ae687face79545_CC2E4397-19F0-4C57-A696-E9C990CA253D.png";

const AwardRecognition = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} className="py-20 md:py-28 bg-[var(--bg-secondary)] relative overflow-hidden" data-testid="award-section">
      {/* Ambient violet glow */}
      <div className="absolute top-1/2 left-1/4 w-[500px] h-[500px] bg-[#7c3aed]/10 rounded-full blur-[120px] -translate-y-1/2" />

      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Award Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7 }}
            className="relative flex justify-center"
          >
            {/* Purple glow behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[450px] bg-[#7c3aed]/15 rounded-full blur-[80px]" />
            <img
              src={AWARD_IMG}
              alt="Raulvin Coke receiving the Educator of the Future Award at AI NEXTGEN America Futurist Awards"
              className="relative rounded-2xl w-full max-w-lg object-cover shadow-2xl shadow-black/60"
              data-testid="award-image"
            />
          </motion.div>

          {/* Right: Copy */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="space-y-6"
          >
            <p className="text-xs uppercase tracking-[0.3em] text-[var(--accent-violet-light)] font-semibold">
              Recognition
            </p>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white italic leading-tight">
              Recognized for Building the Future of Education
            </h2>
            <p className="text-[var(--text-secondary)] leading-relaxed text-base md:text-lg">
              Agentic FuturePath AI was recognized with the <span className="text-white font-medium">Educator of the Future Award</span> at AI NEXTGEN America for work at the intersection of artificial intelligence, education, workforce transformation, and future readiness.
            </p>
            <p className="text-[var(--text-secondary)] leading-relaxed">
              The recognition reflects a broader mission: helping students, families, professionals, and institutions make better decisions in a world being rapidly reshaped by artificial intelligence.
            </p>
            <a
              href="#"
              className="inline-flex items-center gap-2 bg-[var(--accent-violet)] hover:bg-[#6d28d9] text-white px-6 py-3 rounded-full font-semibold text-sm transition-all shadow-lg shadow-violet-900/30"
              data-testid="award-read-story"
            >
              Read the Story
              <ArrowRight className="w-4 h-4" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AwardRecognition;
